import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

interface BaseObject {
    element: string,
    origin?: string,
}

@Injectable({providedIn: 'root'})
export class TrackingsService {
    actionEvents: typeof ActionEventsEnum = ActionEventsEnum;

    constructor(
        private store: Store<AppState>
    ){}

    public sendMetricsToMixpanel(action: ActionEventsEnum | string, payload: BaseObject | Object) {
        this.sendToTracking(action, payload);
    }
    
    private sendToTracking(typeAction: string, eventsTracking: Object) {
        const payload = { type: typeAction, events: eventsTracking };
        this.store.dispatch({ type: TrackingActions.trackEvents, payload: payload });
    }
}